module.exports = __webpack_public_path__ + "img/ic_saas_checked.9581981f.svg";